module.exports = __webpack_public_path__ + "p5_img2.jpg?db368d967dd0705c7df7fd606bcfbdde";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p5/p5_img2.jpg
// module id = 115
// module chunks = 0